// ─── Brand Configuration ────────────────────────────────────────────────────
// Flip WIND_ALLCAPS to true  → every "Wind" / "wind" renders as "WIND"
// Flip WIND_ALLCAPS to false → standard "Wind" casing is preserved
// ────────────────────────────────────────────────────────────────────────────
export const WIND_ALLCAPS = true;

// Pre-built brand strings for direct use
export const BRAND       = WIND_ALLCAPS ? 'WIND Marketing' : 'Wind Marketing';
export const BRAND_SHORT = WIND_ALLCAPS ? 'WIND' : 'Wind';

/**
 * Replaces every word-boundary "Wind" / "wind" occurrence with "WIND"
 * when WIND_ALLCAPS is enabled. Pass any string through this helper.
 *
 * @param {string} str
 * @returns {string}
 */
export const brandify = (str) =>
  WIND_ALLCAPS ? str.replace(/\bwind\b/gi, 'WIND') : str;
